import DataTable from "@standard/components/DataTable";
import TitleHeader from "@standard/components/TitleHeader";
import JobExpenseForm from "./JobExpenseForm";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const programType = "Master";
const programName = "Job Expense Setup";
const url = "master/jobexpense";
const columns = [
  {
    label: "Job Expense",
    name: "name",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
];

const config = {
  enableActive: true,
  enableEdit: true,
  enableTrash: true,
};

export default function JobExpense() {
  const { path } = useRouteMatch();

  return (
    <>
      <TitleHeader programName={programName} programType={programType} />
      <Switch>
        <Route exact path={path}>
          <DataTable columns={columns} url={url} {...config} />
        </Route>
        <Route path={`${path}/:action/:id?`}>
          <JobExpenseForm url={url} />
        </Route>
      </Switch>
    </>
  );
}
